import React, { Component } from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'
import { Icon, Modal, Tooltip } from 'antd'
import { Typography } from 'antd'
import LazyLoad from 'react-lazyload'

const { Paragraph } = Typography

class ItemSideImage extends Component {
    state = {
        modal: false,
    }

    _showModal = () => {
        this.setState({
            modal: true,
        })
    }

    _hideModal = () => {
        this.setState({
            modal: false,
        })
    }


    render() {
        const { side, url, tagFalseDesign } = this.props
        const { popover, modal } = this.state

        return (
            <div className={className('ItemSideImage', { 'hasPreview': url, 'srcEditing': popover })}>
                <div className='Preview position-relative bg-light'>

                    {
                        url &&
                        <LazyLoad>
                            <img src={url} alt='preview' className='position-absolute' />
                        </LazyLoad>
                    }

                    <span className='Side position-absolute'><span className='badge bg-white'>{side}</span></span>

                    <div className='Actions position-absolute'>
                        {
                            url &&
                            <>
                                <div className={`Icon ${tagFalseDesign ? 'FalseDesignAction' : ''}`}>
                                    <Tooltip title="View Image">
                                        <Icon type="eye" onClick={this._showModal} />
                                    </Tooltip>

                                    <Modal visible={modal} closable={false} centered={true} footer={null} width={1000}
                                        onCancel={this._hideModal}>
                                        <img src={url} alt='full' className='d-block m-auto' />
                                    </Modal>
                                </div>
                                <span className='Icon'><Paragraph copyable={{ text: url }} className='mb-0' /></span>
                            </>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

ItemSideImage.defaultProps = {
    url: '',
}

ItemSideImage.propTypes = {
    side: PropTypes.string.isRequired,
    url: PropTypes.string,
    orderId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['update-design', 'update-mock-up']),
}

export default ItemSideImage
